import React, { useState, useEffect } from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Stack, Typography } from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";

import InputPassword from "../../../../components/PasswordInput";

export default function PaswordValidator({ ...props }) {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const isValidLength = password.length >= 8;
  const hasUpperCase = /[A-Z]/.test(password);
  // eslint-disable-next-line no-useless-escape
  const hasSpecialCharacter = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(
    password
  );

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  useEffect(() => {
    if (!isValidLength && !hasUpperCase && !hasSpecialCharacter) return;

    props.handleChange({
      target: {
        name: "password",
        value: password,
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password]);

  return (
    <Stack direction="column" gap="8px">
      <Typography variant="body2" color="secondary" fontWeight={500}>
        {t("registry_inputs.password_label")}
      </Typography>
      <InputPassword
        name="password"
        value={password}
        onChange={handlePasswordChange}
        placeholder={t("registry_inputs.password_placeholder")}
        required
      />
      <Stack direction="column" gap={1}>
        <ValidationRule isValid={isValidLength}>
          {t("registry_inputs.password_requirements.length")}
        </ValidationRule>
        <ValidationRule isValid={hasUpperCase}>
          {t("registry_inputs.password_requirements.uppercase")}
        </ValidationRule>
        <ValidationRule isValid={hasSpecialCharacter}>
          {t("registry_inputs.password_requirements.special_character")}
        </ValidationRule>
      </Stack>
    </Stack>
  );
}

function ValidationRule({ isValid, children }) {
  return (
    <Stack direction="row" gap="8px" alignItems="center">
      <CheckIcon
        color={isValid ? "success" : "secondary.contrastText"}
        fontSize="small"
      />
      <Typography color="secondary.light" variant="caption">
        {children}
      </Typography>
    </Stack>
  );
}
